import { PriceMgr } from './PriceMgr';
export function applyDiscountsForOrderLines(topLevelOrderLines) {
    const newOrderLines = [];
    const recurse = function (line, _newOrderLines) {
        const computedPrices = PriceMgr.compute(line);
        const newLine = Object.assign(Object.assign({}, line), computedPrices);
        newLine.subLines = [];
        if (line.subLines) {
            line.subLines.forEach((subLine) => recurse(subLine, newLine.subLines));
        }
        _newOrderLines.push(newLine);
    };
    topLevelOrderLines.forEach((line) => {
        recurse(line, newOrderLines);
    });
    return newOrderLines;
}
export function accumulatePrices(topLevelOrderLines) {
    const accumulatePricesRecurse = function (line) {
        let totalPriceAccumFromSublinesSummed = 0;
        let totalPriceBeforeAccumFromSublinesSummed = 0;
        let didAnyChildNodeHaveTotalPriceAccum = false;
        let didAnyChildNodeHaveTotalPriceBeforeAccum = false;
        if (line.subLines && line.subLines.length > 0) {
            line.subLines.forEach((subLine) => {
                const { totalPriceAccum, totalPriceBeforeAccum } = accumulatePricesRecurse(subLine);
                if (Number.isFinite(totalPriceAccum)) {
                    totalPriceAccumFromSublinesSummed += totalPriceAccum;
                    didAnyChildNodeHaveTotalPriceAccum = true;
                }
                totalPriceBeforeAccumFromSublinesSummed += totalPriceBeforeAccum
                    ? totalPriceBeforeAccum
                    : totalPriceAccum
                        ? totalPriceAccum
                        : 0;
                if (Number.isFinite(totalPriceBeforeAccum)) {
                    didAnyChildNodeHaveTotalPriceBeforeAccum = true;
                }
            });
        }
        const result = {};
        const myQuantity = line.quantity || 1;
        if (didAnyChildNodeHaveTotalPriceAccum || ('totalPrice' in line && line.totalPrice)) {
            result.totalPriceAccum =
                myQuantity * totalPriceAccumFromSublinesSummed +
                    ('totalPrice' in line && line.totalPrice ? line.totalPrice : 0);
        }
        if (didAnyChildNodeHaveTotalPriceBeforeAccum || ('totalPriceBefore' in line && line.totalPriceBefore)) {
            const effectiveTotalPriceBefore = 'totalPriceBefore' in line && line.totalPriceBefore
                ? line.totalPriceBefore
                : 'totalPrice' in line && line.totalPrice
                    ? line.totalPrice
                    : 0;
            result.totalPriceBeforeAccum = myQuantity * totalPriceBeforeAccumFromSublinesSummed + effectiveTotalPriceBefore;
        }
        Object.assign(line, result);
        return result;
    };
    topLevelOrderLines.forEach(accumulatePricesRecurse);
}
export function aggregateQuantityTopDown(rootOrderLines) {
    function recurse(lines, ancestorQuantity = undefined) {
        lines.forEach((line) => {
            const hasQuantity = line.quantity !== undefined;
            if (hasQuantity) {
                if (ancestorQuantity !== undefined) {
                    line.aggregatedQuantity = ancestorQuantity;
                }
                else {
                    line.aggregatedQuantity = 1;
                }
            }
            function getNewAncestorQuantity() {
                if (ancestorQuantity === undefined && !hasQuantity) {
                    return undefined;
                }
                else {
                    const q1 = ancestorQuantity !== undefined ? ancestorQuantity : 1;
                    const q2 = hasQuantity ? line.quantity : 1;
                    return q1 * q2;
                }
            }
            if (line.subLines && line.subLines.length) {
                const newAncestorQuantity = getNewAncestorQuantity();
                recurse(line.subLines, newAncestorQuantity);
            }
        });
    }
    recurse(rootOrderLines);
}
export function fixPricesForProductsWithFreeAdditionsG5(lines) {
    function fixPricesRecurse(freeQuantity, lines) {
        if (!lines || lines.length === 0) {
            return;
        }
        if (freeQuantity && freeQuantity > 0) {
            lines.sort((a, b) => a.price - b.price);
            let sumQ = 0;
            let i = 0;
            while (sumQ < freeQuantity && i < lines.length) {
                const q = lines[i].quantity;
                const remaining = freeQuantity - sumQ;
                const freeQ = Math.min(q, remaining);
                const newTotalPrice = lines[i].totalPrice - freeQ * lines[i].price;
                if (newTotalPrice === 0) {
                    delete lines[i].totalPrice;
                }
                else {
                    lines[i].totalPrice = newTotalPrice;
                }
                if (!lines[i].tags) {
                    lines[i].tags = {};
                }
                lines[i].tags.freeQuantity = true;
                i++;
                sumQ += freeQ;
            }
        }
        lines.forEach((line) => {
            if (line.subLines) {
                const freeQuantityOfParent = !line.options ? 0 : line.options.freeQuantity || 0;
                fixPricesRecurse(freeQuantityOfParent, line.subLines);
            }
        });
    }
    fixPricesRecurse(0, lines);
}
export function extractAppliedSunsetPoints(orderLines) {
    var _a, _b, _c;
    const discountLine = orderLines === null || orderLines === void 0 ? void 0 : orderLines.find((ol) => ol.name === 'Total Rabat');
    if (((_c = (_b = (_a = discountLine === null || discountLine === void 0 ? void 0 : discountLine.options) === null || _a === void 0 ? void 0 : _a.appliedPriceRule) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.label) === 'SunsetPoints') {
        return Math.round((-1 * discountLine.totalPrice) / (discountLine.options.appliedPriceRule.options.pointsCoefficient || 1));
    }
    return 0;
}
